app.formFeedback = {

    settings: {
        formSelector: "#form-complaint",
        $form : $("#form-complaint")
    },

    init: function() {
        app.formFeedback.settings.$form.on("submit", app.formFeedback.submit);
    },

    submit: function(ev){

        ev.preventDefault();

        app.formFeedback.settings.$form.find(".btn").removeClass("btn--delta btn--dota").addClass("btn--epsilon").attr("disabled", true).html("Bezig met verzenden");

        context.submit({
            method: "submitFeedbackform",
            form: app.formFeedback.settings.formSelector,
            onSuccess: function(response){

                app.formFeedback.showSuccess();
                app.formFeedback.clearForm();
            },
            onError: function(){
                app.formFeedback.showError();
            }
        });
    },

    showSuccess: function() {
        app.formFeedback.settings.$form.find(".btn").removeClass("btn--epsilon").addClass("btn--dota").attr("disabled", false).html("Succesvol verzonden");
    },

    showError: function() {
        alert("Uw bericht kon niet verzonden worden");
        app.formFeedback.settings.$form.find(".btn").removeClass("btn--epsilon btn--dota").addClass("btn--delta").attr("disabled", false).html("Bericht verzenden");
    },

    clearForm: function(){
        app.formFeedback.settings.$form.find("[name=firstname]").val("");
        app.formFeedback.settings.$form.find("[name=surname]").val("");
        app.formFeedback.settings.$form.find("[name=gender]").val("Man");
        app.formFeedback.settings.$form.find("[name=dateofbirth]").val("");
        app.formFeedback.settings.$form.find("[name=address]").val("");
        app.formFeedback.settings.$form.find("[name=zipcity]").val("");
        app.formFeedback.settings.$form.find("[name=phone]").val("");
        app.formFeedback.settings.$form.find("[name=email]").val("");
        app.formFeedback.settings.$form.find("[name=department]").val("");
        app.formFeedback.settings.$form.find("[name=employees]").val("");
        app.formFeedback.settings.$form.find("[name=period]").val("");
        app.formFeedback.settings.$form.find("[name=message]").val("");
    }
};